"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propertyLabelTranslatorWithIsHubSpotDefined = exports.propertyLabelTranslator = exports.propertyDescriptionTranslator = exports.tryYourTranslation = exports.tryLookup = exports.makeDescriptionKey = exports.makeNameSpacedKey = exports.convertToKey = exports.isInvalidString = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _I18n = _interopRequireDefault(require("I18n"));

var _getDescriptionHashKey = _interopRequireDefault(require("./internal/getDescriptionHashKey"));

var re = /[\()\/\.\:\?\,\s\-\–\'&]/gi;
var nameSpaceKey = 'recordProperties';
var descriptionsNameSpaceKey = nameSpaceKey + ".propertyDescriptions";

var silentI18nText = function silentI18nText(key) {
  var temp = _I18n.default.lookup(key);

  var translation = temp && typeof temp !== 'function' && _I18n.default.text(key);

  return translation || undefined;
};

var tryLookup = function tryLookup(key, aString) {
  return silentI18nText(key) || aString;
};

exports.tryLookup = tryLookup;

var isInvalidString = function isInvalidString(maybeString) {
  return typeof maybeString !== 'string' || maybeString.length === 0;
};

exports.isInvalidString = isInvalidString;

var convertToKey = function convertToKey(aString) {
  return isInvalidString(aString) ? '' : aString.replace(re, '_').toLowerCase();
};

exports.convertToKey = convertToKey;

var makeNameSpacedKey = function makeNameSpacedKey(aString) {
  return nameSpaceKey + "." + convertToKey(aString);
};

exports.makeNameSpacedKey = makeNameSpacedKey;

var makeDescriptionKey = function makeDescriptionKey(label, description) {
  return descriptionsNameSpaceKey + "." + (0, _getDescriptionHashKey.default)(description);
};

exports.makeDescriptionKey = makeDescriptionKey;

var tryYourTranslation = function tryYourTranslation(aString, optionalKeyPrefix) {
  var keyString = convertToKey(aString);

  if (!isInvalidString(optionalKeyPrefix)) {
    keyString = optionalKeyPrefix + "." + keyString;
  }

  return tryLookup(keyString, aString);
};

exports.tryYourTranslation = tryYourTranslation;

var propertyLabelTranslator = function propertyLabelTranslator(label) {
  var nameSpaceLookupKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : nameSpaceKey;

  if (label && label === label.toUpperCase()) {
    return label;
  }

  return tryYourTranslation(label, nameSpaceLookupKey);
};

exports.propertyLabelTranslator = propertyLabelTranslator;

var propertyLabelTranslatorWithIsHubSpotDefined = function propertyLabelTranslatorWithIsHubSpotDefined(_ref) {
  var label = _ref.label,
      nameSpaceLookupKey = _ref.nameSpaceLookupKey,
      isHubSpotDefined = _ref.isHubSpotDefined;

  if (isHubSpotDefined !== undefined && !isHubSpotDefined) {
    return label;
  }

  return propertyLabelTranslator(label, nameSpaceLookupKey || nameSpaceKey);
};

exports.propertyLabelTranslatorWithIsHubSpotDefined = propertyLabelTranslatorWithIsHubSpotDefined;

var propertyDescriptionTranslator = function propertyDescriptionTranslator(label, description) {
  if (isInvalidString(description) || (0, _typeof2.default)(_I18n.default.lookup(descriptionsNameSpaceKey)) !== 'object') {
    return description;
  }

  var descriptionKey = makeDescriptionKey(label, description);
  return tryLookup(descriptionKey, description);
};

exports.propertyDescriptionTranslator = propertyDescriptionTranslator;